import { atom } from 'recoil';

const PREFIX_KEY = 'src/atoms/cameraPlayer/';

export const playbackDateAtom = atom<string | null>({
  key: `${PREFIX_KEY}playbackDate.atom`,
  default: null,
});
